import update from 'immutability-helper';

// ------------------------------------
// Constants
// ------------------------------------
export const SET_PURCHASE_SUCCESS_URL = 'SET_PURCHASE_SUCCESS_URL';


export function setPurchaseSuccessUrl(purchaseSuccessUrl) {
	return {
		type: SET_PURCHASE_SUCCESS_URL,
		purchaseSuccessUrl,
	};
}


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SET_PURCHASE_SUCCESS_URL]: (state, action) => update(state, {
		purchaseSuccessUrl: { $set: action.purchaseSuccessUrl },
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
